import { RichTextSpanAttributeType } from "../../model/enums/SDKRichTextSpanAttributeType";
import { TokenTransform } from "../token-transform/SDKToolsTokenTransform";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Search Instance
/** Markdown block transformer */
export class MarkdownTransformUtil {
    // --- Conversion
    constructor(linkResolver) {
        this.tokenTransformer = new TokenTransform();
        this.linkResolver = linkResolver !== null && linkResolver !== void 0 ? linkResolver : null;
    }
    // --- Conversion
    /** Converts rich text block to markdown
     *
     * This is very naive implementation and will break in complicated cases, like double control characters of the same type next to each other
     * Must improve later with something more sophisticated, ideally tree builder with branched resolution.
     */
    async convertTextBlockToMarkdown(block, pageContext) {
        return this.convertRichTextToMarkdown(block.text, pageContext);
    }
    /** Converts rich text to markdown
     *
     * This is very naive implementation and will break in complicated cases, like double control characters of the same type next to each other
     * Must improve later with something more sophisticated, ideally tree builder with branched resolution.
     */
    async convertRichTextToMarkdown(richText, pageContext) {
        var _a;
        let outputString = "";
        for (const text of richText.spans) {
            if (text.text.length > 0) {
                let outputPartial = text.text;
                for (const attribute of text.attributes) {
                    switch (attribute.type) {
                        case RichTextSpanAttributeType.link: {
                            // Resolve link using link resolver if available, otherwise fallback to direct link
                            let linkUrl = (_a = attribute.link) !== null && _a !== void 0 ? _a : "";
                            if (this.linkResolver && pageContext) {
                                linkUrl = await this.linkResolver.resolveLink(attribute.link, attribute.documentationItemId, pageContext);
                            }
                            outputPartial = `[${outputPartial}](${linkUrl})`;
                            break;
                        }
                        case RichTextSpanAttributeType.bold:
                            outputPartial = `*${outputPartial}*`;
                            break;
                        case RichTextSpanAttributeType.code:
                            outputPartial = `\`${outputPartial}\``;
                            break;
                        case RichTextSpanAttributeType.italic:
                            outputPartial = `_${outputPartial}**_`;
                            break;
                        case RichTextSpanAttributeType.strikethrough:
                            outputPartial = `~~${outputPartial}~~`;
                            break;
                        default:
                            throw new Error("Unknown attribute type");
                    }
                }
                outputString += outputPartial;
            }
        }
        return outputString;
    }
    /** Convert token to markdown representation */
    convertTokenToMarkdown(token) {
        return `${token.name}: ${this.tokenTransformer.tokenToCSS(token)}`;
    }
    /** Convert tokens to markdown table representation */
    convertTokensToMarkdownTable(tokens) {
        if (tokens.length === 0) {
            return "";
        }
        // Table header
        const headers = ["Name", "Value"];
        const separators = ["---", "---"];
        const tableRows = [
            `| ${headers.join(" | ")} |`,
            `| ${separators.join(" | ")} |`,
        ];
        // Table rows
        for (const token of tokens) {
            const tokenName = token.tokenPath && token.tokenPath.length > 0
                ? `${token.tokenPath.join(".")} / ${token.name}`
                : token.name;
            const tokenValue = this.tokenTransformer.tokenToCSS(token);
            // Escape pipe characters in cell content
            const escapedName = tokenName.replace(/\|/g, "\\|");
            const escapedValue = tokenValue.replace(/\|/g, "\\|");
            tableRows.push(`| ${escapedName} | ${escapedValue} |`);
        }
        return tableRows.join("  \n");
    }
}
